import React, { useState } from "react";
import Dialog from "material-ui/Dialog";
import TextField from "material-ui/TextField";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import { CardHeader } from "material-ui/Card";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import { getNames } from 'country-list';

const column = {
  width: 350,
  margin: "0px 10px",
  flex: 1
};

const styles = {
  radioButton: {},
  floatingLabelStyle: {
    color: "black",
  }
};

const FisheryMetadataDialog = ({ open, isNew, onRequestClose, metadata, handleSave, modal, hasOldAttrs, copying, ...props}) => {
  metadata = metadata || {};
  if (modal === undefined) {
    modal = true;
  }
  var initCommonName = copying ? metadata.commonName + " - Copy" : metadata.commonName

  const [commonName, setCommonName] = useState(initCommonName || "");
  const [scientificName, setScientificName] = useState(
    metadata.scientificName || ""
  );
  const [fleet, setFleet] = useState(metadata.fleet || "");
  const [country, setCountry] = useState(metadata.country || "");
  const [geography, setGeography] = useState(metadata.geography || "");
  const [context, setContext] = useState(metadata.context || "test");
  const [errors, setErrors] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(false);

  const fields = {
    commonName,
    scientificName,
    fleet,
    geography,
    country
  };

  const validateFields = () => {
    const errors = {};
    for (let key in fields) {
      const val = fields[key];
      if (!val || !val.length) {
        errors[key] = "Required"
      }
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return false;
    } else {
      setDisableSubmit(true);
      handleSave({
        commonName,
        scientificName,
        fleet,
        country,
        geography,
        context
      });
    }
  };

  return (
    <Dialog
      onRequestClose={onRequestClose}
      open={open}
      modal={modal}
      title={copying ? "Update Fishery Information For Copied Fishery?" : "Fishery Information"}
      autoScrollBodyContent={true}
      actions={[
        ...(isNew || !hasOldAttrs ? [<FlatButton label="Cancel" primary={false} onClick={onRequestClose} />] : []),
        <RaisedButton
          label={copying ? "Copy Fishery" : "Submit"}
          primary={true}
          onClick={validateFields}
          disabled={disableSubmit}
        />
      ]}
    >
      {isNew &&
        `
        The following fields are used to clearly define the fishery for this FishPath Tool application.
         Use commas to separate responses if multiple species, fleet or gear.
         Enter NA if unknown.`}
      {hasOldAttrs &&
        `
        It appears this fishery was evaluated with an older version of FishPath. Please fill in the
        following characteristics so that the Tool can better evaluate your fishery. Use commas to separate
         responses if multiple species, fleet or gear. Enter NA if unknown.
      `}
      {
        copying && "This information will be applied to the new copy. It will not affect the current fishery."
      }
      <br />
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={column}>
          <TextField
            value={commonName}
            onChange={e => setCommonName(e.target.value)}
            floatingLabelText="Fishery Common Name(s)"
            hintText="e.g., California Market Squid"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
            errorText={errors.commonName}
          />
          <br />
          <TextField
            value={scientificName}
            onChange={e => setScientificName(e.target.value)}
            floatingLabelText="Genus species"
            hintText="e.g., Doryteuthis opalescens"
            errorText={errors.scientificName}
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
          />
          <br />
          <TextField
            value={fleet}
            onChange={e => setFleet(e.target.value)}
            floatingLabelText="Fleet and Gear Type(s)"
            hintText="e.g., Commercial Purse Seine"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
            floatingLabelFixed={true}
            errorText={errors.fleet}
          />
          <br />
        </div>
        <div style={column}>
          <SelectField
          floatingLabelText="Country (May Select Multiple)"
          hintText="e.g., United States, Canada"
          errorText={errors.country}
          multiple={true}
          value={country}
          onChange={(event, index, values) => setCountry(values)}
          maxHeight={200}
          floatingLabelFixed={true}
          floatingLabelStyle={styles.floatingLabelStyle}
          >
            {  getNames().sort(function (a, b) {
                return a.localeCompare(b);
              }).map((name) => <MenuItem key={name} value={name} primaryText={name} />) }
          </SelectField>
          <TextField
            value={geography}
            onChange={e => setGeography(e.target.value)}
            floatingLabelText="Geographic Area of the Fishery"
            hintText="e.g., California Coast"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
            floatingLabelFixed={true}
            errorText={errors.geography}
          />
        </div>
        <div>
          <CardHeader title="In which of these 3 contexts is the FishPath Tool being used for this fishery?" subtitle="This information is collected to better understand Tool use patterns."/>
          <RadioButtonGroup
            name="context"
            valueSelected={context}
            onChange={(e, v) => setContext(v)}
          >
            <RadioButton
              value="test"
              label="Exploratory test run"
              style={styles.radioButton}
            />
            <RadioButton
              value="facilitated-stakeholder-group"
              label="Facilitated workshop for specific fishery"
              style={styles.radioButton}
            />
            <RadioButton
              value="individual"
              label="Individual use for specific fishery"
              style={styles.radioButton}
            />
          </RadioButtonGroup>
        </div>
      </div>
    </Dialog>
  );
};

export default FisheryMetadataDialog;
